export default __webpack_public_path__ + "static/media/ic_norway.8f8db4b9.svg";